// extracted by mini-css-extract-plugin
module.exports = {"new_main_page_range_block_wrapper":"RangeBlock_new_main_page_range_block_wrapper__VqNBi"};